import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { Icon, Button, IconButton, Tooltip } from '@material-ui/core';
import ReactTable from "react-table";
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import * as Actions from './store/actions';
import * as paramActions from '../../components/paramHistory/store/actions';
import * as TableActions from 'main/components/tableSort/store/actions';
import TableCellTooltip from '../../components/TableCellTooltip';
import * as HelperFunctions from '../../components/helpers'; 

const styles = theme => ({
    layoutRoot: {},
});

class CourseLessonList extends Component {

    constructor(props) {
        super(props);
    }

    handleRowClick(page_type, lesson) {

        const Unscheduled = this.props.currentCourse.Unscheduled

        function compare(a, b) {
            if (Unscheduled === 1) {
                if (a.DisplayOrder < b.DisplayOrder) {
                    return -1;
                }
                if (a.DisplayOrder > b.DisplayOrder) {
                    return 1;
                }
            }
            else {
                if (a.LessonDay < b.LessonDay) {
                    return -1;
                }
                if (a.LessonDay > b.LessonDay) {
                    return 1;
                }
            }

            // a must be equal to b
            return 0;
        }

        const withDay =
            this.props.lessonList.map((le) => {
                return {
                    ...le,
                    LessonDay: le.WeekNum * 7 + le.DayOfWeek - 7
                }
            })

        const sorted = withDay.sort(compare);
        const curLesson = sorted.find(l => l.lesson_id === lesson.lesson_id)

        this.props.saveCourse(this.props.currentCourse, this.props.lessonList, this.props.prereqs, this.props.auth_id, this.props.companies);
        this.props.editLessonClickParams({
            active: true,
            course_id: this.props.currentCourse.course_id,
            CourseName: this.props.currentCourse.CourseName,
            LessonName: lesson.LessonName,
            startingPoint: 'course',
            lessonCycleActive: true,
            completedLessons: sorted,
            lessonListIndex: sorted.indexOf(curLesson),
            lessonListWeek: curLesson.WeekNum,
            courseUnscheduled: Unscheduled
        });
        this.props.history.push(`/lesson/${page_type}/${lesson.lesson_id}`);
    }

    render() {
        const { classes, lessonList, table_sort } = this.props;
        const table_name = this.constructor.name;

        const sorter = (a, b) => {
            if (a.DayValue < b.DayValue) {
                return -1;
            }
            if (a.DayValue > b.DayValue) {
                return 1;
            }
            // a must be equal to b
            return 0;
        }

        const unscheduledSorter = (a, b) => {
            if (a.DisplayOrder < b.DisplayOrder) {
                return -1;
            }
            if (a.DisplayOrder > b.DisplayOrder) {
                return 1;
            }
            return 0;
        }

        let withIndex = []

        if (this.props.currentCourse.Unscheduled === 0) {

            const lessonCalc = lessonList.map(lesson => {
                return {
                    ...lesson,
                    DayValue: (lesson.WeekNum - 1) * 7 + lesson.DayOfWeek
                }
            }).sort(sorter)

            withIndex = lessonCalc.map((lesson, index) => {
                return {
                    ...lesson,
                    Order: index + 1
                }
            })
        }
        else {
            withIndex = this.props.lessonList
                .sort(unscheduledSorter)
                .map((lesson, index) => {
                    return {
                        ...lesson,
                        Order: index + 1
                    }
                })
        }

        return (
            <ReactTable
                columns={[
                    {
                        Header: "Lesson Name",
                        // accessor: "LessonName"
                        Cell: row => (
                            <TableCellTooltip
                                item={row.original.LessonName}
                                chars={20}
                            />
                        )
                    },
                    {
                        Header: "Order",
                        // accessor: a => (a.WeekNum * 7 + a.DayOfWeek - 7).toString(),
                        // accessor: a => lessonList.indexOf(a) + 1,
                        accessor: a => a.Order,
                        id: 'Order'
                    },
                    {
                        Header: "Week",
                        accessor: "WeekNum"
                    },
                    {
                        Header: "Day of Week",
                        accessor: "DayOfWeek"
                    },
                    {
                        Header: "",
                        Cell: row => (
                            <div className="flex items-center">
                                <IconButton
                                    style={{ padding: '0px', marginLeft: '5px', marginRight: '5px' }}
                                    onClick={(ev) => {
                                        ev.stopPropagation();
                                        this.handleRowClick('detail', row.original);
                                    }}
                                >
                                    <Icon>library_books</Icon>
                                </IconButton>
                                {!HelperFunctions.checkPermission(this.props.auth.user.data.permissionList, "lesson", "edit") || this.props.match.params.view_type === 'detail' ? null :
                                    <IconButton
                                        style={{ padding: '0px', marginLeft: '5px', marginRight: '5px' }}
                                        onClick={(ev) => {
                                            ev.stopPropagation();
                                            this.handleRowClick('edit', row.original);
                                        }}
                                    >
                                        <Icon>border_color</Icon>
                                    </IconButton>
                                }


                            </div>
                        )
                    }
                ]}
                data={withIndex}
                defaultPageSize={25}
                className="-striped -highlight"
                noDataText="No Lessons Found"
                defaultSorted={table_sort[table_name]}
                onSortedChange={(sort_list) => this.props.setTableSort(this.props.auth.user.data.auth_id, table_name, sort_list)}
            />
        );
    }


}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        saveCourse: Actions.saveCourse,
        editLessonClickParams: paramActions.updateCourseBuilderParams,
        setTableSort: TableActions.setTableSort,
    }, dispatch);
}

function mapStateToProps({ tableSort, auth }) {
    return {
        table_sort: tableSort.table_sort,
        auth
    }
}

export default withStyles(styles, { withTheme: true })(withRouter(connect(mapStateToProps, mapDispatchToProps)(CourseLessonList)));


// WEBPACK FOOTER //
// src/main/content/course/CourseLessonList.js